import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxKuvUtilsModule } from 'ngx-kuv-utils';
import { NgxKuvToolsModule } from 'ngx-kuv-tools';
import { NgSelectModule } from '@ng-select/ng-select';
import { TipoGastosCreateComponent } from './tipo-gastos-create/tipo-gastos-create.component';
import { TipoGastosUpdateComponent } from './tipo-gastos-update/tipo-gastos-update.component';
import { TipoGastosIndexComponent } from './tipo-gastos-index/tipo-gastos-index.component';
const routes: Routes = [
  { path: 'index', component: TipoGastosIndexComponent },
  { path: '**', redirectTo: 'index' }
];


@NgModule({
  declarations: [
    TipoGastosCreateComponent,
    TipoGastosUpdateComponent,
    TipoGastosIndexComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    ReactiveFormsModule,
    FormsModule,
    NgxKuvUtilsModule,
    NgxKuvToolsModule,
    NgSelectModule
  ]
})
export class TipoGastosModule { }
